import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  title: () => faker.lorem.sentence(),
  name: () => faker.lorem.word(),
  message: () => faker.lorem.paragraph(),
  defaultChannels: () => faker.helpers.arrayElements(['email', 'sms', 'push'], faker.number.int({ min: 1, max: 3 })),
  defaultEmployeeAudiences: () =>
    faker.helpers.arrayElements(['all', 'department', 'team'], faker.number.int({ min: 1, max: 3 })),
  defaultVisitorAudiences: () =>
    faker.helpers.arrayElements(['visitors', 'contractors', 'vendors'], faker.number.int({ min: 1, max: 3 })),
  published: () => faker.datatype.boolean(),
  markAsSafe: () => faker.datatype.boolean(),
  takeoverActive: () => faker.datatype.boolean(),
  createdAt: () => faker.date.past(),
  updatedAt: () => faker.date.recent(),
  announcementTemplateCategory: association(),
  locations: () => [],
});
